"use strict";
/**
 * Novig → the Kalshi-shaped rows the fan-out pickers render (additional- and
 * parallel-markets modals), as `pm-us-adapters.ts` does for PM-US
 * (ai/NOVIG_VENUE_PLAN.md phase 9.4). A row carries what a leg needs later:
 * the outcome ids (a leg is not the market on screen) and the side names.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.novigEventToEvent = novigEventToEvent;
exports.novigMarketToMarketFromEvent = novigMarketToMarketFromEvent;
const novig_fetcher_1 = require("../../../markets/novig-fetcher");
function novigEventToEvent(e) {
    return { event_ticker: e.id, title: e.title, category: "novig", sub_title: e.subtitle };
}
function novigMarketToMarketFromEvent(m, eventId) {
    // Through the same projection as the primary picker, so slots, labels and
    // types can never disagree between the two.
    const market = (0, novig_fetcher_1.novigProjectedMarketToMarket)(m);
    return {
        ticker: m.id,
        event_ticker: eventId,
        title: m.title,
        subtitle: market.subtitle,
        yes_sub_title: market.yesSubtitle,
        no_sub_title: market.noSubtitle,
        novigOutcomeIds: market.novigOutcomeIds,
        marketCategory: market.marketCategory,
        marketCategoryLabel: market.marketCategoryLabel,
        marketCoarseType: market.marketCoarseType,
        status: m.status,
        // No list prices: the live book is the only Novig price.
        yes_bid_dollars: "0",
        yes_ask_dollars: "0",
        no_bid_dollars: "0",
        no_ask_dollars: "0",
        last_price_dollars: "0",
        volume_fp: "0",
        open_interest_fp: "0",
        expiration_time: "",
    };
}
